import React, { ReactElement } from 'react';
import useStyles from './styles';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations, CanModify } from './configuration';
import { Typography } from '@material-ui/core';
import {
  AppSelect,
  AppTextField,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { SchemeTypes } from '../../../../config';
import { getState } from '../../../../redux/store';
import { ReducerKeys } from '../../../../redux/reducers';
import { FormFields } from '../../configuration';
import * as RegistrationDetailSelectors from 'redux/reducers/registration_detail_reducer/selectors';

interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type: SchemeTypes;
  is_agent: boolean;
  isExcluded: boolean;
  errors: DeepMap<FormFields, FieldError>;
  control: Control<FormFields>;
  getValues: any;
}

export default function ChangeIdentification(props: IProps): ReactElement {
  // console.log('Render ChangeIdentification');
  const mode = props.mode;

  return (
    <div>
      <Typography variant="h5">
        <TranslatedText textMap={Translations.header} />
      </Typography>
      <p>
        <TranslatedText textMap={Translations.subtitle} />
      </p>
      <ChangeIdentificationForm
        mode={mode}
        scheme_type={props.scheme_type}
        is_agent={props.is_agent}
        errors={props.errors}
        control={props.control}
        isExcluded={props.isExcluded}
        getValues={props.getValues}
      />
    </div>
  );
}

interface IFormProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type: SchemeTypes;
  is_agent: boolean;
  errors: DeepMap<FormFields, FieldError>;
  control: Control<FormFields>;
  isExcluded: boolean;
  getValues: any;
}
function ChangeIdentificationForm(props: IFormProps): ReactElement {
  // console.log('Render ChangeIdentificationForm');
  const classes = useStyles();
  const mode = props.mode;
  const SCHEME_TYPE = props.scheme_type;
  const IS_AGENT = props.is_agent;
  const errors = props.errors;
  const control = props.control;
  const isExcluded = props.isExcluded;

  return (
    <GridLayout
      elements={[
        {
          element: renderCountryField(
            errors,
            control,
            mode,
            SCHEME_TYPE,
            IS_AGENT,
            isExcluded,
            props.getValues
          ),
          size: 4,
          id: 'countryCI',
        },
        {
          element: renderVatNumberField(
            errors,
            control,
            mode,
            SCHEME_TYPE,
            IS_AGENT,
            isExcluded,
            props.getValues
          ),
          size: 4,
          id: 'vatNumCI',
        },
      ]}
      justify="flex-start"
    />
  );
}

const renderCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean,
  getValues: any
) => {
  // let countries = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
  //   .nonMemberStateCountries.data;
  let countries = RegistrationDetailSelectors.useGetCountriesMemberState();
  let select_countries = [];
  select_countries.push({
    id: null,
    label: Translations.country_label.English,
  });
  if (countries && countries.length > 0)
    for (let country of countries)
      select_countries.push({
        id: country.country_id,
        label: country.description,
      });

  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="changeIdentification_country"
      label={<TranslatedText textMap={Translations.country_label} />}
      error={'changeIdentification_country' in errors}
      name="changeIdentification_country"
      control={control}
      rules={{
        validate: () =>
          getValues('changeIdentification_vatNum') &&
          !getValues('changeIdentification_country')
            ? 'This field is requried since you have insert VAT Number'
            : null,
      }}
      options={select_countries as any}
      helperText={
        errors.changeIdentification_country &&
        errors.changeIdentification_country.message
      }
      disabled={
        !CanModify[SCHEME_TYPE](IS_AGENT).includes(
          'changeIdentification_country'
        ) || mode === 'VIEW'
      }
    />
  );
};

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT',
  SCHEME_TYPE: SchemeTypes,
  IS_AGENT: boolean,
  isExcluded: boolean,
  getValues: any
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="changeIdentification_vatNum"
      label={<TranslatedText textMap={Translations.vat_number_label} />}
      error={'changeIdentification_vatNum' in errors}
      name="changeIdentification_vatNum"
      control={control}
      rules={{
        validate: () =>
          getValues('changeIdentification_country') &&
          !getValues('changeIdentification_vatNum')
            ? 'This field is requried since you have selected a country'
            : null,
      }}
      helperText={
        errors.changeIdentification_vatNum &&
        errors.changeIdentification_vatNum.message
      }
      disabled={
        !CanModify[SCHEME_TYPE](IS_AGENT).includes(
          'changeIdentification_vatNum'
        ) || mode === 'VIEW'
      }
    />
  );
};
